var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottomRightCorner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 370,
    height: 193,
    viewBox: "0 0 370 193",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.6491 0.877441H0.111328V64.8691H73.6491V0.877441Z",
    fill: "#14F595"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M221.898 192.972C202.534 192.973 183.36 189.655 165.47 183.207C147.581 176.759 131.325 167.308 117.633 155.393C103.941 143.478 93.0795 129.334 85.6696 113.766C78.2597 98.1985 74.4465 81.5132 74.4473 64.6631H147.319C147.319 81.875 155.177 98.3819 169.163 110.553C183.149 122.723 202.118 129.561 221.898 129.561C241.677 129.561 260.647 122.723 274.633 110.553C288.62 98.3819 296.477 81.875 296.477 64.6631H369.35C369.35 135.411 303.202 192.972 221.898 192.972Z",
    fill: "#CAFCE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomRightCorner);
export default __webpack_public_path__ + "static/media/bottom_right_corner.2a7c65a515aae2502921edcb710bf63d.svg";
export { ForwardRef as ReactComponent };